<div
  class="discussion-pagination"
  *ngIf="visible && totalPages > 1"
>
  <button
    type="button"
    class="discussion-pagination--btn"
    [disabled]="currentPage === 1"
    (click)="onPageChange(1)"
    aria-label="First page"
  >
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path d="M11 18L5 12L11 6M18 18L12 12L18 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
  <button
    type="button"
    class="discussion-pagination--btn"
    [disabled]="currentPage === 1"
    (click)="onPageChange(currentPage - 1)"
    aria-label="Previous page"
  >
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
  <div class="discussion-pagination--numbers">
    <button
      *ngFor="let page of getPageNumbers()"
      type="button"
      class="discussion-pagination--number"
      [class.active]="page === currentPage"
      (click)="onPageChange(page)"
    >
      {{ page }}
    </button>
  </div>
  <button
    type="button"
    class="discussion-pagination--btn"
    [disabled]="currentPage === totalPages"
    (click)="onPageChange(currentPage + 1)"
    aria-label="Next page"
  >
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
  <button
    type="button"
    class="discussion-pagination--btn"
    [disabled]="currentPage === totalPages"
    (click)="onPageChange(totalPages)"
    aria-label="Last page"
  >
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path d="M13 18L19 12L13 6M6 18L12 12L6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
</div>
